import React from 'react'
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';

const CompAdminExamenItem = (props) => {
    const [value, setValue] = React.useState('');
    console.log(value);
    

    const handleChange = (event) => {
        setValue(event.target.value);
        let mewObject = {...props.examen}
        mewObject.cRespuestas[props.index-1] = event.target.value;
        mewObject.dPuntajes[props.index-1] = 2;
        props.setExamen(mewObject)
    };

    return (
       <div>

  <FormControl component="fieldset">
     
      <RadioGroup row aria-label="position" name="position" defaultValue="top" value={value} onChange={handleChange}>
      <FormLabel component="legend">Pregunta Nro {props.index}:</FormLabel>
        <FormControlLabel
          value="A"
          control={<Radio color="primary" />}
          label="A"
          labelPlacement="start"
        />
        <FormControlLabel
          value="B"
          control={<Radio color="primary" />}
          label="B"
          labelPlacement="start"
        />
        <FormControlLabel
          value="C"
          control={<Radio color="primary" />}
          label="C"
          labelPlacement="start"
        />
         <FormControlLabel
          value="D"
          control={<Radio color="primary" />}
          label="D"
          labelPlacement="start"
        />
                 <FormControlLabel
          value="E"
          control={<Radio color="primary" />}
          label="E"
          labelPlacement="start"
        />
        
      </RadioGroup>
    </FormControl>

      </div>
    )
}

export default CompAdminExamenItem
